import React from "react";
import "./styles/Divider.css";

interface DividerProps {
  margin?: string;
}

const Divider: React.FC<DividerProps> = ({ margin = "2rem 0" }) => {
  return <hr className="custom-divider" style={{ margin }} />;
};

export default Divider;
